import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
// import { SET_ANNOUNCEMENT_DISPLAYED_STATE } from "../../../store/actionTypes";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
  },
  paper: {
    // backgroundColor: theme.palette.background.paper,
    backgroundColor: "white",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1, 2, 1),
    width: "400px",
    borderRadius: "1rem",
  },
  title: {
    textAlign: "center",
    alignItems: "center",
    color: "#e95914",
    fontSize: "28px",
    fontWeight: 600,
    paddingTop: 20,
  },
  body: {
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    fontSize: "26px",
    fontWeight: 600,
    color: "black",
  },
}));

export default function AnnouncementModal({ title, body, imageSrc }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  // const dispatch = useDispatch();

  // const handleOpen = () => {
  //   setOpen(true);
  // };

  const handleClose = () => {
    setOpen(false);
    sessionStorage.setItem("isAnnouncementDisplayed", "true");
  };

  return (
    <div>
      {/* <button type="button" onClick={handleOpen}>
        react-transition-group
      </button> */}
      <Modal
        onClick={handleClose}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <p className={classes.title}>{title}</p>
            <p className={classes.body}>
            {body}
            </p>
            {/* <img
              style={{
                maxWidth: "568px",
                width: "100%",
              }}
              src="/assets/images/2023/deprem_takvim_degisiklik_2.png"
            />  */}
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
